import React from 'react';

const RenderFields = ({
  fields,
  formData,
  handleChange,
  readOnly = false,
  fieldTransformers = {},
  validationErrors = {},
}) => {
  return fields.map((field) => {
    const isFieldReadOnly = readOnly || field.key === 'customerID' || field.isDisabled;

    if (field.type === 'select' && field.options) {
      // Use RenderFieldsDropdown for select fields
      return (
        <RenderFieldsDropdown
          key={field.key}
          fields={[field]}
          formData={formData}
          handleChange={handleChange}
          readOnly={readOnly}
          validationErrors={validationErrors}
        />
      );
    }

    if (field.type === 'checkbox') {
      // Handle checkbox fields
      return (
        <div key={field.key} className="flex items-center w-full pb-2">
          <label
            className="p-2 w-1/3 h-16 flex items-center text-gray-500"
            style={{
              lineHeight: '1.2',
              wordBreak: 'break-word'
            }}
          >

            {field.label}
            <span className="flex-grow border-dotted border-b-4 border-gray-200 m-2"></span>
          </label>
          <input
            name={field.key}
            type="checkbox"
            checked={formData[field.key]}
            onChange={() => handleChange({ target: { name: field.key, value: !formData[field.key] } })}
            disabled={isFieldReadOnly}
            className={`${isFieldReadOnly ? 'cursor-not-allowed' : ''}`}
            style={{ width: '20px', height: '20px' }}


          />
        </div>
      );
    }

    // Handle standard fields
    return (
      <div key={field.key} className="flex flex-col w-full">
        <div className="flex items-center w-full pb-2">
          <label
            className="p-2 w-1/3 h-16 flex items-center text-gray-500"
            style={{
              lineHeight: '1.2',
              wordBreak: 'break-word'
            }}
          >
            {field.label}
            <span className="flex-grow border-dotted border-b-4 border-gray-200 m-2"></span>
          </label>
          <input

            min={field.min || 0}
            max={field.max || 100}

            minLength={field.min || 0}
            maxLength={field.max || 100}

            name={field.key}
            type={field.type || 'text'}
            className={`border ${validationErrors[field.key] ? 'border-red-500' : 'border-gray-300'
              } flex-grow p-2 ${isFieldReadOnly ? 'bg-gray-100' : ''}`}
            value={
              fieldTransformers[field.key]
                ? fieldTransformers[field.key](formData[field.key])
                :

                field.map ? field.map[formData[field.key]] : formData[field.key]

                  || ''
            }
            onChange={(e) => handleChange({ target: { name: field.key, value: field.type == 'number' ? Number(e.target.value) : e.target.value } })}
            readOnly={isFieldReadOnly}

          />
        </div>
        {validationErrors[field.key] && (
          <div className="text-red-500 text-sm text-right">
            {validationErrors[field.key]}
          </div>
        )}
      </div>
    );
  });
};

const RenderFieldsDropdown = ({
  fields,
  formData,
  handleChange,
  readOnly = false,
  validationErrors = {},
}) => {
  return fields.map((field) => (
    <div key={field.key} className="flex flex-col w-full">
      <div className="flex justify-between items-center w-full pb-2">
        <label
          className="p-2 w-1/3 h-16 flex items-center text-gray-500"
          style={{
            lineHeight: '1.2',
            wordBreak: 'break-word'
          }}
        >
          {field.label}
          <span className="flex-grow border-dotted border-b-4 border-gray-200 m-2"></span>
        </label>
        <select
          name={field.key}
          className={`border ${validationErrors[field.key] ? 'border-red-500' : 'border-gray-300'
            } flex-grow p-2 my-auto ${readOnly ? 'bg-gray-100' : ''}`}
          value={formData[field.key] || ''}
          onChange={handleChange}
          disabled={readOnly}
          style={{ borderRadius: '0' }}
        >
          <option value="">Select an option</option>
          {field.options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
      {validationErrors[field.key] && (
        <div className="text-red-500 text-sm mt-1 ml-2">
          {validationErrors[field.key]}
        </div>
      )}
    </div>
  ));
};

export { RenderFields, RenderFieldsDropdown };
